import { Box, Container, Paper, Stack, Typography } from "@mui/material";
import background from '../../assets/howto/background.png'
import Grid from '@mui/material/Grid2';
import { HowToGetStartedProps } from "../../interfaces";

const HowToGetStarted = ({
  steps,
  title = "How to get",
  highlightedTitle = "started",
  backgroundImage = background,
  backgroundColor = "darkPurple.500",
  headerBackgroundColor = "beige.200",
  innerHeader = false
}: HowToGetStartedProps) => {
  return (
    <Paper
      elevation={0}
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        bgcolor: backgroundColor,
        borderRadius: "12px",
        maxWidth: "1320px",
        margin: "0 auto",

        width: "100%",
        alignSelf: {xs: "stretch"},
      }}
    >

      {!innerHeader && <Box
        sx={{
          display: "flex",
          height: {md: "126px", sx: "98px"},
          alignItems: "center",
          justifyContent: {md: "space-between", sm: "center", xs: "center"},
          width: "100%",
          bgcolor: headerBackgroundColor, 
          padding: {xs: "32px 20px", md: "0 48px"},
          borderTopLeftRadius: "11px",
          borderTopRightRadius: "11px",
          // gap: {xs: '16px', md: '0'},
          flexWrap: {xs: 'wrap', md: 'nowrap'}
        }}
      >
        <Typography
          variant="subtitle8"
          sx={{
            whiteSpace: "break-spaces",
            textTransform: "uppercase",
            textWrap: "wrap",
          }}
        >
          <Box component="span" sx={{ color: "darkPurple.500" }}>
            {title}{" "}
          </Box>
          <Box component="span" sx={{ color: "lightPurple.500" }}>
            {highlightedTitle}
          </Box>
        </Typography>
      </Box> }

      <Container maxWidth="lg" 
      sx={{
            background: backgroundImage ? `url(${backgroundImage})` : undefined, 
            backgroundSize: 'cover', 
            backgroundPosition: 'center',
            padding: {md: '80px 0', xs: '40px 0'},
            display: 'flex',
            alignItems: {md: 'flex-start', sm: 'center', xs: 'center'},
            alignSelf: 'stretch',
            flexDirection: {md: 'row', sm: 'column', xs: 'column'},
        }}>
        <Grid container spacing={4} justifyContent="center" sx={{width: '100%'}}>
        {innerHeader && <Grid size={{xs: 12}} sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}>
               <Typography
               variant="subtitle8"
              sx={{
                whiteSpace: "nowrap",
                textTransform: "uppercase",
                textAlign: 'center',
              }}
            >
              <Box component="span" sx={{ color: "beige.100" }}>
                {title}{" "}
              </Box>
              <Box component="span" sx={{ color: "lightPurple.500" }}>
                {highlightedTitle}
              </Box>
            </Typography>
          </Grid>}
          {steps.map((step, index) => (
            <Grid
              key={index}
              size={{ xs: 12, sm: 12, md: 4 }}
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
                gap: {md: "32px", sm: "20px", xs: "20px"},
              }}
            >
              <Box
                sx={{
                  width: {md: "48px", sm: "44px", xs: "44px"},
                  height: {md: "48px", sm: "44px", xs: "44px"},
                  bgcolor: "#CDBCF3", 
                  borderRadius: "12px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "column",
                  gap: {md: "0px", xs: "10px"},
                  padding: {md: "11px 0", xs: "10px"},
                }}
              >
                <Typography
                  variant="subtitle11"
                  sx={{
                    color: "darkPurple.500",
                  }}
                >
                  {step.number}
                </Typography>
              </Box>

              <Stack alignItems="center" spacing={2}>
                <Typography
                variant="subtitle3"
                  sx={{
                    color: "beige.100",
                    textAlign: "center",
                    whiteSpace: "pre-line",
                    textTransform: "uppercase",
                  }}
                >
                  {step.title}
                </Typography>

                <Typography
                  variant="body7"
                  sx={{
                    color: "darkPurple.100",
                    textAlign: "center",
                    whiteSpace: "pre-line",
                    textTransform: "uppercase",
                  }}
                >
                  {step.description}
                </Typography>
              </Stack>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Paper>
  );
};

export default HowToGetStarted;
